import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-2 col-xl-4 col-lg-5 col-md-6" }
const _hoisted_3 = { class: "header-left-side justify-content-md-start d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-3" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "col-10 col-sm-8 col-xl-8 col-lg-7 col-md-6" }
const _hoisted_7 = { class: "header-right-side d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_8 = { class: "dropdown profile-dropdown" }
const _hoisted_9 = {
  class: "text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  "aria-expanded": "false"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user fs-30" }, null, -1)
const _hoisted_11 = { class: "title d-lg-block ms-10 ms-lg-15" }
const _hoisted_12 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_13 = { class: "text-body-emphasis fw-semibold fs-13" }
const _hoisted_14 = {
  key: 0,
  class: "dropdown warehouse-dropdown"
}
const _hoisted_15 = {
  class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent transition border-0 lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-map fs-30" }, null, -1)
const _hoisted_17 = { class: "title d-none d-lg-block ms-10 ms-lg-15" }
const _hoisted_18 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_19 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_20 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-maps-and-flags" }, null, -1)
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "dropdown apps-dropdown" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LightDarkSwtichBtn = _resolveComponent("LightDarkSwtichBtn")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
      { sticky: _ctx.isSticky },
    ]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0 d-xl-none",
            id: "header-burger-menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
          }, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_LightDarkSwtichBtn),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.userName), 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.merchantName), 1)
              ])
            ])
          ]),
          (_ctx.warehouses.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("button", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.warehouseName), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("ul", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (warehouse) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "text-body-secondary fw-semibold transition position-relative",
                        key: warehouse.id
                      }, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(warehouse.name) + " ", 1),
                        _createElementVNode("a", {
                          onClick: _withModifiers(($event: any) => (_ctx.updateWarehouse(warehouse.id)), ["prevent"]),
                          class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                        }, null, 8, _hoisted_22)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              class: "dropdown-toggle p-0 position-relative bg-transparent border-0 transition lh-1",
              type: "button",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.logout()), ["prevent"]))
            }, _hoisted_25)
          ])
        ])
      ])
    ])
  ], 2))
}